import React, { useState, useEffect } from "react";
// import "./index.scss";
// import axiosInstance from "../../../../services/api/API";
// import CustomTable from "../../../../customComponents/CustomTable";
import { useNavigate } from "react-router-dom";
// import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
// import viewIcon from "../../../../../Assets/icons/eye 1.svg";

import viewIcon from "../../../../Assets/icons/eye 1.svg"

// import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import { IoMdClose } from "react-icons/io";
import download from "../../../../Assets/icons/download.svg";
import moment from "moment";
import * as base64 from "base-64";
// import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
// import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";
import axiosInstance from "../../../services/api/API";
import CustomTable from "../../../customComponents/CustomTable";
import ListLogisticsFilters from "../../Logistics/LogisticsFilter";
import SearchInput from "../../../customComponents/CustomSearch/SearchInput";
import ROUTES_NAVIGATION from "../../../../routes/routes";

const WarrantyClaims = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [jobCardList, setJobCardList] = useState([]);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecored] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [filters, setFilters] = useState({});
  const [totalJobRecord, setTotalJobRecord] = useState(null);
  // const [tableLoader,setTableLoader]=useState(false);

  const dealer_id = localStorage.getItem("dealerId");
  const userType = localStorage.getItem("UserType");

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  localStorage.removeItem('JobCardComplainData')

  useEffect(() => {
    fetchJobCardList();
  }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchJobCardList(newPage);
  };
  const DownLoadPdf = (row) => {
    var text = row?.job_card_id;
    var encoded = base64.encode(text);
    const pdfURL = `${process.env.REACT_APP_API_BASE_URL}jobcardpdfreport/jobCardInvoiceDownload/${encoded}`;
    window.open(pdfURL, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    fetchJobCardList()
  },[])

  const fetchJobCardList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    const payload= {
      // business_partner_id: 1,
      orderBy: "claimWarrantyId desc",
      page,
      pageSize,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
      searchText: searchTerm,
      dealer_id: userType === "businesspartner" ? null : dealer_id,
    }
    try {
      // setTableLoader(true)
      const response = await axiosInstance.post(
        "/jobcard/warranty-claim-list",payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // setTableLoader(false)
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        // Job_Verify: item?.solved == 0 ? "Pending" : "Done",
        vinNum:item.vinNum || "- -",
        remark:item.remark || "- -",
        job_card_no: onClickNavigetion(item),
        transaction_date: moment(item?.transaction_date).format("DD/MM/YYYY"),

        // status: item?.status == 0 ? "Pending" : "Done",
      }));
      if (response?.status == 200) {
        setJobCardList(formattedData);
        setTotalRecored(response?.data?.data?.totalRecords);
        setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
        setTotalJobRecord(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span style={{ color: "green" }}> {item?.job_card_no}</span>
      </div>
    );
  };

  const Status = (item) => {
    return (
      <div
        style={{
          display: "flex",
          backgroundColor: item?.solved == 0 ? "#FEEBEB" : "#E4F7E3",
          width: 90,
          justifyContent: "center",
          paddingTop: 4,
          paddingBottom: 4,
          borderRadius: 10,
        }}
      >
        <span style={{ fontSize: 18 }}>
          {item?.solved == 0 ? "Pending" : "Done"}
        </span>
      </div>
    );
  };

  const handleEdit = (rowData) => {
    navigate("add-job-card", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const handleViewButton = (rowData) => {
    navigate(ROUTES_NAVIGATION.WARRANTYCLAIMSDETAILS, {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  // const filteredBusinessPartners = businessPartners.filter((item) =>
  //   item.bp_name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  // Table headers
  const Job_Card_TABLE_HEADERS = [
    "Claim Code",
    "Claim Name",
    "Vin No.",
    // "Warranty From Date",
    // "Warranty To Date",
    // "Repair Status",
    "Remarks",
    // "Job Type",
    // "Item Image",
    // "OEM Item Status",
    "Claim Status",
    // "Job Status",
    "Action",
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Claim Code": "claimCode",
    "Claim Name": "claimName",
    "Vin No.": "vinNum",
    "Remarks": "remark",
    "Registration No.": "registration_no",
    "Claim Status":"status",
    // "Vin No.":"vinNum",
    "Repair Status":"repairStatus",
    "Inspect By":"inspection_by",
    "Vehicle Type": "product_name",
    "Pin Code":"pincode",
    "Job Type":"jobTypeName",
    "Item Image":"imagepath",
    "OEM Item Status":"itemstatus",
    "Job Status": "status",
    Action: [
      // {
      //   type: "edit",
      //   icon: editIcon,
      //   label: "Edit",
      // },

      {
        type: "view",
        icon: viewIcon,
        label: "View",
      },
    //   {
    //     type: "print",
    //     icon: download,
    //     label: "Print",
    //   },
    ],
    // "Print": "Print"
  };

  // const handleClicableRow = (row) => {
  //   alert("hello")
  //   setFilterList(row);
  // };

  const onclickFilter = (row) => {
    setFilterList(row);
  };

  useEffect(() => {
   
    fetchJobCardList();
  }, [filters]);

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchJobCardList();
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchJobCardList();
    }
  }, [searchTerm]);

  const handleSearch = () => {
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
    });
  };
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handelkeyDown = (event) => {
    if (event.key === "Enter") {
      fetchJobCardList({ searchText: searchTerm });
    }
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
    },
  ];

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div  className="OnboardManagamentbuttonContainer  col-md-3 mt-2 mb-2">
          <div style={{lineHeight:"1px",display:"flex",flexDirection:"column" }}>
          <div>
          <p className="ServiceBreadcrumbs" >Services / Warranty Claims</p>
          </div>
          <div>
          <h5 style={{fontWeight:"600"}} >Warranty Claims</h5>
          </div>
          </div>
        </div>
        <div className=" col-md-8 mt-2 mb-2 gap-2 totalvaluescontainer">
          {/* <div className="topleftdataContainer">
            <div className="listTopDataValueText">
              {totalJobRecord?.total || 0}{" "}
            </div>
            <div>Total Job</div>
          </div> */}
          {/* <div className="topleftdataContainer">
            <div className="listTopDataValueText">
              {totalJobRecord?.total_pending || 0}{" "}
            </div>
            <div>Pending Job</div>
          </div> */}
          {/* <div
            // key={}
            className="topleftdataContainer"
          >
            <div className="listTopDataValueText">
              {totalJobRecord?.total_completed || 0}{" "}
            </div>
            <div>Completed Job</div>
          </div> */}
          {/* <div
            // key={}
            className="topleftdataContainer"
            style={{ paddingRight: "10px" }}
          >
            <div className="listTopDataValueText">
              &#8377;{totalJobRecord?.total_revenue || 0}
            </div>
            <div>Revenue</div>
          </div> */}
          <div className="listSideBorder" />

          {/* <button
            className="addcustomerbutton"
            onClick={() => navigate("add-Job-Card")}
          >
            Add Job Card
          </button> */}
        </div>
      </div>
      <div className="tableWrapper">
        <div className="filterView">
          <div className="filterLeftView col-md-4 pt-4 gap-2">
            <h5>Claim List</h5>
            <div>
              <SearchInput
               placeholder="Search..."
                onSearch={fetchJobCardList}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
          <div className="filterRightView col-md-8 gap-2">
            <div className="mt-3">
              {/* <h5 style={{paddingTop:"20px"}} >Filter By</h5> */}
            </div>
          
            {/* <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
              // onSubmit={handleFormSubmit}
            /> */}
          </div>
        </div>

        <CustomTable
          data={jobCardList}
          headers={Job_Card_TABLE_HEADERS}
          keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
          onEdit={handleEdit}
          handleViewButton={handleViewButton} // Pass the handleEdit function
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        //  handleClicableRow={handleClicableRow}
          pdfDownLoad={DownLoadPdf}
          totalRecords={totalRecords}
          // tableLoaderShow={tableLoader}
        />
      </div>
    </div>
  );
};

export default WarrantyClaims;
